var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-wrapper" },
    [
      _c(
        "div",
        { staticClass: "detail-section" },
        [
          _c("a-form", { attrs: { layout: "vertical" } }, [
            _c(
              "div",
              { staticClass: "detail" },
              [
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_ar_invoice_number") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.invoiceNumber || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_invoice_date") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm._f("date")(_vm.detailData.invoiceDate)
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_customer") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.customerName || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_tax_type") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.taxType || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_term_of_payment") }
                  },
                  [
                    _c("a-input", {
                      attrs: { disabled: "", value: _vm.detailData.top || "-" }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_currency") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.currency || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_purchase_order_number") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.poNumber || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_reference_number") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.referenceNumber || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_invoice_tax_no") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.invoiceTaxNo || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_customer_name") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.customerName || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_ship_to") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.shipTo || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_usage_type") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.usageType || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_description") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.description || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_discount") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.discount || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_base_amount") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.taxBase || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_sub_total") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.subTotal || "-"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  { staticClass: "mb-0", attrs: { label: _vm.$t("lbl_vat") } },
                  [
                    _c("a-input", {
                      attrs: { disabled: "", value: _vm.detailData.ppn || "-" }
                    })
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  {
                    staticClass: "mb-0",
                    attrs: { label: _vm.$t("lbl_total") }
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.detailData.grandTotal || "-"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("TableCustom", {
        attrs: {
          idtable: "table-invoice-summary",
          dataSource: _vm.detailData.arLines || [],
          columns: _vm.columnsTableDetail,
          scroll: { x: "calc(300px + 50%)", y: 700 },
          paginationcustom: false,
          defaultPagination: false,
          size: "small"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }